import { useCallback, useEffect, useState } from 'react';

import LoadingBar from '../../../global/LoadingBar';
import OffersV2Shelf from '../OffersV2Shelf';
import { getGenericError } from '../../../utils/errors';
import { getSleekOffers } from '../../../utils/service';
import {
  ANCHOR_OFFERS,
} from '../../../config/routes';
import { getTrackerId, POSTHOG_CAPTURE_ATTRIBUTES, TRACKER_IDS } from '../../../config/tracker';

const PREVIEW_PAGE_SIZE = 9;

const {
  dashboard: {
    earnTrashiecash: {
      viewAllButton: trackerViewAllButton,
    },
  },
} = TRACKER_IDS;

const OffersPreviewV2 = () => {
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const loadOffers = useCallback(async () => {
    setIsLoading(true);

    const {
      data,
      error: offersError,
    } = await getSleekOffers();

    if (offersError) {
      setListData([]);
      setError(offersError.message ?? getGenericError());
      setIsLoading(false);
      return;
    }

    setError('');
    setListData(data.splice(0, PREVIEW_PAGE_SIZE));
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadOffers();
  }, []);

  return (
    isLoading ? (<LoadingBar />) : (
      <OffersV2Shelf
        anchor={ANCHOR_OFFERS}
        offersList={listData}
        title="Shop and Earn"
        noData={listData.length ? undefined : 'No offers available at the moment'}
        error={error}
        ctaTrackerProps={{
          [POSTHOG_CAPTURE_ATTRIBUTES.TRACKER_ID]: getTrackerId(trackerViewAllButton),
        }}
        isDashBoard
      />
    )
  );
};

export default OffersPreviewV2;
